import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

export const PAYMENT_TAGS = {
  LIST: 'PAYMENT_LIST'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [PAYMENT_TAGS.LIST]
});

export const paymentApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listPaymentHistory: build.query({
      async queryFn(args) {
        const { skip = 0, pageSize = 25, searchValue = '' } = args || {};

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          ...(searchValue ? { Filter: { Value: searchValue } } : {}),
          OrderBy: 'Created',
          OrderDirection: 'desc'
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.PAYMENTTXN,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: PAYMENT_TAGS.LIST, id: 'LIST' }]
    })
  })
});

export const { useListPaymentHistoryQuery } = paymentApi;
